var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import clsx from 'clsx';
import { CategorySelector } from './CategorySelector';
import { PopularKeywords } from './PopularKeywords';
import { Search } from './Search';
export var FilterSearch = function (_a) {
    var title = _a.title, onSearch = _a.onSearch, searchProps = _a.searchProps, keywordProps = _a.keywordProps, categoryProps = _a.categoryProps;
    return (React.createElement("div", { className: clsx('faq-filter-search', 'faq-filter-search__container') },
        title && (React.createElement(Typography, { variant: "h2", className: "faq-filter-search__title" }, title)),
        React.createElement("div", { className: clsx('faq-filter-search__inner') },
            React.createElement(Search, __assign({}, searchProps)),
            categoryProps && React.createElement(CategorySelector, __assign({}, categoryProps)),
            React.createElement(Button, { variant: "contained", color: "secondary", disableElevation: true, className: clsx('faq-filter-search__button', 'faq-filter-search-button'), startIcon: React.createElement(SearchIcon, null), onClick: onSearch }, "\u691C\u7D22")),
        keywordProps && React.createElement(PopularKeywords, __assign({}, keywordProps))));
};
//# sourceMappingURL=FilterSearch.js.map